var angular = require('angular');
var _module = require('./index');

require('../core/utils');
require('../events');
require('./contact-form');
require('./counterpart-info');

_module.directive('lenderSlide', [function () {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/lender-slide.tmpl.html',
        scope: {
            report: '=',
            showFullscreenLoader: '=',
            hideFullscreenLoader: '=',
            isMobile: '=',
            selectedHelpOption: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function () {
                var vm = this;

                vm.options = [
                    { name: 'Getting pre-approved' },
                    { name: 'Learning about home purchase options' },
                    { name: 'Other' }
                ];

            }
        ]
    };
}]);
